export const DEFAULT_CUSTOM_THEME_COLOR = {
  key: "custom",
  primary: "#a260ab",
  secondary: "#fce8fa",
};
